import { s3 } from "./AwsS3";

type Props = {
  file: any;
  userId?: string;
  folderName: string;
  caseId?: string;
  inmateName?: string;
};

/**
 * Uploads an image to AWS S3.
 * @component uploadImageToS3
 * @author Sanjay
 *
 */

export const uploadDpsToS3 = async ({ file, caseId, inmateName }: any) => {
  const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;
  // console.log({ caseId }, { inmateName });
  if (!bucketName) {
    throw new Error("AWS Bucket name is not defined in environment variables.");
  }

  // const params = {
  //   Bucket: bucketName, // Now we are sure it's a string
  //   Key: `document/${inmateName}-${caseId}/Report`,
  //   ContentType: file.type,
  //   Body: file,
  // };

  const timestamp = Date.now();
  const folderName = "Uploaded Documents";
  // const fileName = `Report-${timestamp}`;
  const extension = file.name.split(".").pop(); // get file extension
  const fileName = `Report-${timestamp}.${extension}`;
  const params = {
    Bucket: bucketName,
    Key: `document/${inmateName}-${caseId}/Report-${timestamp}`,
    ContentType: file.type,
    Body: file,
  };

  try {
    const data = await s3.upload(params).promise();

    const destinationKey = `Cases/${inmateName}-${caseId}/${folderName}/${fileName}`;
    // const uploadDocumentParams = {
    //   Bucket: bucketName,
    //   CopySource: `document/${inmateName}-${caseId}/${fileName}`,
    //   Key: destinationKey,
    // };
    const uploadDocumentParams = {
      Bucket: bucketName,
      Key: destinationKey,
      ContentType: file.type,
      Body: file,
    };
    // Copy within S3
    // await s3.copyObject(uploadDocumentParams).promise();
    await s3.upload(uploadDocumentParams).promise();

    return data;
  } catch (err: any) {
    throw new Error(`Upload failed: ${err.message}`);
  }
};
